<template>
  <!-- 爷爷盒子 -->
  <!-- 阻止点击事件冒泡 -->
  <div @click.stop>
    <div class="grad_father_box" :style="{'width':scrollbarFatherBox}" >
      <!-- 父盒子 -->
      <div class="father_box" ref="fatherBox" @click="onclick" :style="{'width':scrollbarFatherBox}"
        @mousedown="spanMouseDown">
        <!-- 生成的标签 -->
        <!-- <el-scrollbar style="height: 100%;" class="scrollbar-for"> -->

        <!-- <div style="width:100%" ref="tagsWidth"> -->
        <div :style="{'width':scrollbar}">
          <i class="el-icon-search" style="margin-top: 5px; font-size: 18px; width: 25px;"
            @click="searchTagsContent"></i>

          <div v-for="(item,index) in TagsAll" :key="index" class="spanbox">
            <span class="tagspan">{{item}}</span>
            <span class="span_close" @click="removeTag(index,item)" @mousedown="spanMouseDown">
              <i class="el-icon-close"></i>
            </span>
            <!-- </div> -->
          </div>
          <!-- 输入框 -->
          <input placeholder="点击此处添加筛选条件" v-model="currentval" @keyup.enter="addTagsEnter" @keyup.delete="deleteTags"
             :style="inputStyle" class="inputTag" ref="inputTag" type="text" @click="toCenter" />
        </div>

        <!-- </el-scrollbar> -->
      </div>
    </div>

    <!-- :style="sty" -->

    <el-card v-show="showContent" :style="sty">
      <div v-if="selectType == false ">
        <el-scrollbar style="height: 100%;width: 100%;margin-left: 10px;" class="scrollbar-for-y">
          <div class="choose-bank">
            <ul style="overflow: auto;margin-left: -10px;">
              <li v-for="(item, index) in typeSelect" @click="chooseType($event, index, item.label)"
                @mouseover="mouseOver($event, index, item.label)" @mouseleave="mouseLeave($event, index, item.label)"
                :key="index" :class="{ 'choose-bank-selected': chooseFlag == index }">
                <span style="margin-left: 15px;">{{item.label}}</span>
              </li>
            </ul>
          </div>
        </el-scrollbar>
      </div>

      <div v-else>
        <div class="choose-bank">
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%; margin-top: -20px"
            max-height="200" @selection-change="handleSelectionChange" :row-style="{height: '0',}"
            :cell-style="{padding:'3px'}">
            <el-table-column type="selection" width="50">
            </el-table-column>
            <el-table-column prop="name" label="全选" width="120" :show-overflow-tooltip="true">

            </el-table-column>
          </el-table>
          <div style="margin-top: 20px">
            <el-button type="primary" @click="toggleSelection()">确认</el-button>
            <el-button @click="toggleSelectionCancel()">取消</el-button>
          </div>
          <!-- <ul style="overflow: auto;width: 180px;">
              <li v-for="(item, index) in chooseTypeData" @click="chooseContent($event, index, item.name)"
                @mouseover="mouseOverContent($event, index, item.name)"
                @mouseleave="mouseLeaveContent($event, index, item.name)" :key="index"
                :class="{ 'choose-bank-selected': chooseFlag == index }">
                <span style="margin-left: 15px;">{{item.name}}</span>
              </li>
            </ul> -->
        </div>
      </div>
    </el-card>

  </div>

</template>

<script>
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import "vue-custom-scrollbar/dist/vueScrollbar.css"
  import {
    getEntityData
  } from '@/api/entity'

  import {
    getCarTypes
  } from '@/api/car'
  export default {
    components: {
      vueCustomScrollbar
    },
    name: 'inputTags',
    props: {

      limit: {
        // 最多生成标签数，这里可以设置最多生成的标签数量
        type: Number,
      },
    },
    data() {
      return {
        tableData: [],
        tableDataEntity: [],
        tableDataType: [],
        tableDataStatus: [{
          value: 0,
          name: "正常",
        }, {
          value: 1,
          name: "未接入",
        }, {
          value: 3,
          name: "建图",
        }, {
          value: 4,
          name: "建轨迹",
        }, {
          value: 5,
          name: "自动任务",
        }, {
          value: 6,
          name: "遥控驾驶",
        }, {
          value: 7,
          name: "待机",
        }, {
          value: 2,
          name: "故障",
        }, {
          value: 64,
          name: "异常",
        }],
        multipleSelection: [],
        count: 10,
        loading: false,

        // chooseBankLimit: 4, //默认显示4个银行
        chooseFlag: null, //选择银行的标识
        currentval: '',
        TagsAll: [],
        inputLength: '',
        height: '32px',
        settings: {
          suppressScrollY: true,
          suppressScrollX: false,
          wheelPropagation: false
        },
        widthScrollArea: '110px',
        typeSelect: [{
            label: '机器人状态',
            field: 'checker',
            type: 'checkbox',
            group: 'Personnel-related',
            filterKey: 'name',
            options: [{
                name: 'Jack',
              },
              {
                name: 'Tom',
              },
              {
                name: 'Jerry',
              },
            ],
          },

          {
            label: '所属单位',
            field: 'checker',
            type: 'checkbox',
            group: 'Personnel-related',
            filterKey: 'name',
            options: [{
                name: 'Jack',
              },
              {
                name: 'Tom',
              },
              {
                name: 'Jerry',
              },
            ],
          },
          {
            label: '机器人类型',
            field: 'creator',
            type: 'radio',
            group: 'Personnel-related',
            filterKey: 'name',
            options: [{
                name: 'Jack',
              },
              {
                name: 'Tom',
              },
              {
                name: 'Jerry',
              },
            ],
          },
        ],

        blurIndex: 0,
        showContent: false,
        /* mouse_x: '0.px',
        mouse_y: '0.px', */
        sty: {
          'margin-top': '20px',
          'margin-left': '20px',
          'width': '220px',
          'height': '140px',
          'margin': '10px',
          position: 'fixed',
          top: '0px',
          left: '10px',
          'z-index': 999,
          // overflow:hidden
        },
        selectContent: false,
        selectType: false,

        inputSelectType: "",
        inputSelectContent: "",

        // 宽度
        scrollbarFatherBox: '800px',
        scrollbarContent: 300,
        scrollbar: '790px',
        entityId: this.$store.getters['user/entityId'],
      }
    },
    watch: {
      TagsAll() {
        this.$emit('on-change', this.finall)
      },
      currentval() {
        // 实时改变input输入框宽度，防止输入内容超出input默认宽度显示不全
        this.inputLength = this.$refs.inputTag.value.length * 12 + 50;
      },

    },
    computed: {

      //选择银行
      /* chooseFilter() { //截取 4 个银行
         return this.chooseBankData.slice(0, this.chooseBankLimit);
       }, */
      noMore() {
        return this.count >= 20
      },
      disabled() {
        return this.loading || this.noMore
      },
      inputStyle() {

        let style = {};
        style.width = `${this.inputLength}px`;
        return style;
      },
      //将生成的数据拼接成字符串，因为我们公司后台需要这种格式的数据。
      finall() {
        return this.TagsAll.join(',')
      }
    },
    mounted() {
      //监听鼠标点击
      document.addEventListener('click', (e) => {
        
        this.showContent = false;
      })  
      // this.TagsAll = this.initValue;
      getEntityData(this.entityId).then(res => {
        // 获取运营单位成功，更新entity
        this.tableDataEntity = [];

        for (var key in res.data[0]) {
          this.tableDataEntity.push({
            value: key,
            name: res.data[0][key]
          });
        }

      }).catch(error => {
        reject(error)
      });

      getCarTypes(this.entityId).then(res => {
        // 获取运营单位成功，更新entity
        this.tableDataType = [];
        for (let i = 0; i < res.data.length; i++) {
          var nameStr = res.data[i]["name"] + "-" + res.data[i]["model"];
          this.tableDataType.push({
            value: res.data[i]["id"],
            name: nameStr
          });
        }

      }).catch(error => {
        reject(error)
      });
    },
    methods: {

      toggleSelection() {

        if (this.multipleSelection.length == 0) {
          this.$message({
            message: '请先选择',
            type: 'warning'
          });
        } else {
          this.inputSelectContent = '';
          for (let i = 0; i < this.multipleSelection.length; i++) {
            this.inputSelectContent += this.multipleSelection[i].name;
            if (i != this.multipleSelection.length - 1) {
              this.inputSelectContent += "|";
            }
          }
        }
        this.sty.height = "140px";
        this.showContent = false;
        this.addTags();
      },

      toggleSelectionCancel() {
        this.showContent = false;
      },

      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

      searchTagsContent() {
        this.$emit('queryDevice', this.TagsAll);
      },

      load() {
        this.loading = true
        setTimeout(() => {
          this.count += 2
          this.loading = false
        }, 2000)
      },
      // 移入
      mouseOver(e, index, name) {
        this.chooseFlag = index

      },
      // 移出
      mouseLeave(e, index, name) {
        this.chooseFlag = null

      },
      //选择中
      chooseType(e, index, name) {
        this.chooseFlag = index
        this.inputSelectType = name;
        this.showContent = false;

        if (name == "机器人状态") {
          this.tableData = this.tableDataStatus;
        } else if (name == "所属单位") {
          this.tableData = this.tableDataEntity;
        } else if (name == "机器人类型") {
          this.tableData = this.tableDataType;
        }

        this.addTags();
        this.selectType = true;
        this.showContent = true;
      },

      // 移入
      mouseOverContent(e, index, name) {
        this.chooseFlag = index

      },
      // 移出
      mouseLeaveContent(e, index, name) {
        this.chooseFlag = nullz

      },
      //选择中
      chooseContent(e, index, name) {
        this.chooseFlag = index
        this.inputSelectContent = name;
        this.showContent = false;
        this.addTags();

        this.selectType = false;
      },


      toCenter(event) {
        if (this.showContent == false) {
          const {
            pageX,
            pageY
          } = event
          this.sty["margin-left"] = pageX + 'px';
          this.sty["margin-top"] = pageY + 'px';
          this.showContent = true;
        }

      },
      scrollHanle(evt) {},
      removeTag(index) {
        this.TagsAll.splice(index, 1)
      },
      spanMouseDown(e) {
        if (this.selectType == true) {
          this.selectType = false
        }
        e.preventDefault()
      },

      addTags(e) {
        this.$refs.fatherBox.style.borderColor = '#dcdee2'
        this.$refs.boxShadow = '0'
        this.height = '32px'
        this.validInput()
        this.widthScrollArea = '100px';
        this.showContent = false;
      },

      //回车-- 增加tag
      addTagsEnter(e) {

        this.$refs.fatherBox.style.borderColor = '#dcdee2'
        this.$refs.boxShadow = '0'
        this.height = '32px'
        this.TagsAll.push("关键字:" + this.currentval);
        var tagsWidth = document.getElementsByClassName("spanbox");
        console.log(tagsWidth)
        this.scrollbarContent = 265;
        if (tagsWidth.length > 0) {
          for (let i = 0; i < tagsWidth.length; i++) {
            console.log(tagsWidth[i].offsetWidth);
            this.scrollbarContent += tagsWidth[i].offsetWidth + 35;

            this.scrollbar = this.scrollbarContent + "px";
          }
        }
        this.sty.height = "280px";
        this.currentval = '';
      },
      // 增加校验规则
      validInput() {

        if (this.limit && this.TagsAll.length === this.limit) {
          this.$Message.info(`最多可输入${this.limit}个标签`)
          return
        }

        // 距离头部150
        // this.$refs.fatherBox.scrollIntoView(false);

        this.$refs.fatherBox.scrollTop = 500

        if (this.selectType == true) {

          this.TagsAll.splice(this.TagsAll.length - 1, 1)
          this.TagsAll.push(this.inputSelectType + ":" + this.inputSelectContent);

          //设置标签父容器宽度
          //该部分应放到添加TagsAll之后，使用setTimeout的原因是因为直接获取，
          //他的width一直为56，不清楚是否为异步操作
          setTimeout(() => { 
            var tagsWidth = document.getElementsByClassName("spanbox");
            console.log(tagsWidth)
            this.scrollbarContent = 265;

            if (tagsWidth.length > 0) {
              for (let i = 0; i < tagsWidth.length; i++) {
                console.log(tagsWidth[i].offsetWidth);
                this.scrollbarContent += tagsWidth[i].offsetWidth + 35;

                this.scrollbar = this.scrollbarContent + "px";
              }
            }
          },1)


          // 显示选择框
          this.selectType = false;
        } else if (this.selectType == false) {

          this.TagsAll.push(this.inputSelectType + ":");

          setTimeout(() => { 
            var tagsWidth = document.getElementsByClassName("spanbox");
            console.log(tagsWidth)
            this.scrollbarContent = 265;
            if (tagsWidth.length > 0) {
              for (let i = 0; i < tagsWidth.length; i++) {
                console.log(tagsWidth[i].offsetWidth);
                this.scrollbarContent += tagsWidth[i].offsetWidth + 35;

                this.scrollbar = this.scrollbarContent + "px";
              }
            }
          },1)

          this.sty.height = "280px";
          // 显示选择框
          this.selectType = true;
        }


      },
      //键盘删除键删除tag
      deleteTags() {
        if (this.currentval) return
        this.TagsAll.pop()
      },
      onclick() {

        this.$nextTick(() => {
          this.$refs.inputTag.focus();
          this.$refs.fatherBox.style.borderColor = '#57a3f3'
          this.$refs.fatherBox.style.outline = 0
          this.$refs.boxShadow = '0 0 0 2px #57a3f3 0.2'
          this.height = 'auto'
        })
      },

    },
    // 在组件生命周期结束时销毁
    beforeDestroy() {
      window.removeEventListener('click', () => {}, true)
    }
  }
</script>

<style scoped>
  .scrollbar-for {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .scrollbar-for-y {
    .el-scrollbar__wrap {
      overflow-y: hidden;
    }
  }

  .infinite-list-wrapper {
    width: 200px;
    height: 400px;
  }

  /* 选择 */
  .choose-bank {
    width: auto;
    height: auto;
  }

  .choose-bank ul li {
    width: 150px;
    height: 34px;
    line-height: 34px;
    float: left;

    margin-right: 12px;
    margin-bottom: 0px;
    overflow: hidden;
    cursor: pointer;
    position: relative;

  }

  /* 选择银行 - 选中状态 */
  .choose-bank ul li.choose-bank-selected {
    border-radius: 5px;
    /* 设置为圆角 四周圆40px 可调  越小越接近直角 */
    background-color: #eaeaeb;
  }

  .choose-bank ul li.choose-bank-selected>i {
    display: block;
    width: 18px;
    height: 18px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .scroll-area {
    position: relative;
    margin: auto;
    width: 400px;
    height: 40px;
  }

  .grad_father_box {
    /* width: 300px; */
    position: relative;
    min-height: 32px;
  }

  /* 外层div */
  .father_box {

    box-sizing: border-box;
    background-color: white;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    font-size: 12px;
    text-align: left;
    padding-left: 5px;
    word-wrap: break-word;
    overflow: hidden;
    border-radius: 5px;
    position: absolute;
    overflow: auto;
    /* width: 300px; */

  }

  .father_box:focus {
    border-color: #57a3f3;
    /* outline: 0; */
    box-shadow: 0 0 0 2px #57a3f3 0.2;
  }

  /* 标签 */
  .spanbox {
    margin-right: 5px;
    cursor: pointer;
    display: inline-table;
    background: #dde6fa;
    padding: 2px 0;
    border: 1px solid transparent;
    border-radius: 2px;
    color: #544b49;
    font-size: 12px;
    vertical-align: top;
    padding: 3px;
    margin-bottom: 4px;
    margin-top: 2px;
  }

  .tagspan {
    padding-right: 5px;
      white-space: nowrap;  /*强制span不换行*/
    display: inline-block;  /*将span当做块级元素对待*/
    overflow: hidden;  /*超出宽度部分隐藏*/
    text-overflow: ellipsis;  /*超出部分以点号代替*/
    line-height: 0.9;  /*数字与之前的文字对齐*/
  }

  .span_close {
    padding-left: 3px;
    border-left: 2px solid #dde6fa;
  }

  .span_close:hover {
    color: red;
  }

  /* input */
  .inputTag {
    font-size: 12px;
    border: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
    padding: 0;
    /* width: auto; */
    min-width: 240px;
    vertical-align: top;
    height: 30px;
    color: #495060;
    line-height: 30px;
    display: inline-block;
  }

  /*  .is-tooltipStyle {
    background: #fff;
    color: #3759af;
    border: 1px solid rgb(158, 157, 157);
    font-size: 15px;
  } */
</style>
